"use strict";

exports.__esModule = true;
var isEvent = function isEvent(candidate) {
  return !!(candidate && candidate.stopPropagation && candidate.preventDefault);
};

exports.default = isEvent;


//////////////////
// WEBPACK FOOTER
// ./~/redux-form/lib/events/isEvent.js
// module id = 109
// module chunks = 76301927324276 76662671623916 231608221292675